/* Millesève — formulaire de contact (E4.4, DS §10.7).
   Vérifie l'e-mail à l'envoi et en quittant le champ (jamais pendant la frappe) : s'il est vide ou invalide,
   rien n'est envoyé (clic et Entrée bloqués), le champ passe en aria-invalid, le message s'écrit dans sa zone role="status"
   et le focus revient au champ. Sans ce script, Shopify renvoie form.errors (rendu par la section). */
(function () {
  function init(form) {
    if (form.dataset.msContact) return;
    form.dataset.msContact = 'pret';
    var champ = form.querySelector('#ContactForm-email');
    var zone = form.querySelector('#ContactForm-email-error');
    if (!champ || !zone) return;
    var message = form.getAttribute('data-message-email') || '';

    function valide() {
      return champ.value.trim() !== '' && champ.checkValidity();
    }
    function signale() {
      champ.setAttribute('aria-invalid', 'true');
      champ.setAttribute('aria-describedby', zone.id);
      zone.textContent = message;
    }
    function efface() {
      champ.removeAttribute('aria-invalid');
      champ.removeAttribute('aria-describedby');
      zone.textContent = '';
    }

    function bloque(e) {
      if (valide()) return;
      e.preventDefault();
      signale();
      champ.focus();
    }
    // Le clic (ou Entrée, qui clique le bouton) est vérifié avant l'envoi : la protection anti-spam de Shopify
    // intercepte l'événement submit des vrais clics et renvoie le formulaire elle-même, sans passer par ici.
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(function (bouton) {
      bouton.addEventListener('click', bloque);
    });
    form.addEventListener('submit', bloque);
    champ.addEventListener('blur', function () {
      if (champ.value.trim() === '') return;
      if (valide()) efface();
      else signale();
    });
    champ.addEventListener('input', function () {
      if (champ.getAttribute('aria-invalid') === 'true' && valide()) efface();
    });
  }

  // Retour de Shopify après l'envoi : focus sur le champ en erreur, sinon sur le message.
  function focusEtat() {
    var etat = document.getElementById('ContactForm-etat');
    if (!etat) return;
    var fautif = document.querySelector('#ContactForm [aria-invalid="true"]');
    (fautif || etat).focus();
  }

  function tout() {
    document.querySelectorAll('form#ContactForm').forEach(init);
  }
  tout();
  // Après le chargement complet : d'autres scripts du thème reprennent le focus pendant le chargement.
  if (document.readyState === 'complete') focusEtat();
  else window.addEventListener('load', function () { setTimeout(focusEtat, 0); });
  document.addEventListener('shopify:section:load', tout);
})();
